export default "__VITE_ASSET__EQI663Dy__"